/** @format */

import type {FlashpointYandexChangeGroup} from 'graphql/generated/types';

export type DetailedScatterData = {
  date: string;
  value: number;
};

export type TooltipScatterData = {
  // Начало периода. Обычно это самая первая дата, либо начало периода после предыдущей кнопки.
  // Если undefined, то начало совпадает с концом
  startOn?: string;
  // Конец периода. Совпадает с датой, на которой размещается эта кнопка.
  endOn: string;
  // Детализированные данные по каждой дате периода. Сортированы от меньшей даты к большей.
  details?: DetailedScatterData[];
  // Разбивка по группам изменений. Заполняется только для логов Яндекса
  // (когда aggregateScatter получил groupCollection). У заметок отсутствует.
  byGroup?: GroupBreakdown;
};

export type ScatterButtonData = {
  // Общее число данных за период с предыдущей даты.
  value: number;
  tooltipData: TooltipScatterData;
};

export type ScatterData = {
  [date: string]: ScatterButtonData;
};

export type ScatterCollection = {
  [date: string]: number;
};

// Зеркалит backend-enum FlashpointYandexChangeGroup; satisfies ловит дрейф схемы
// на этапе компиляции. Рантайм-массив нужен для Set-проверки в маппере, который
// сводит неизвестные значения к OTHER.
export const YANDEX_CHANGE_GROUPS = [
  'CAMPAIGN',
  'AD_GROUP',
  'AD',
  'TARGETING',
  'KEYWORDS',
  'BIDS',
  'BUDGET',
  'STATUS',
  'OTHER',
] as const satisfies readonly FlashpointYandexChangeGroup[];

export type YandexChangeGroup = (typeof YANDEX_CHANGE_GROUPS)[number];

export type GroupBreakdown = Partial<Record<YandexChangeGroup, number>>;

// Logs-only коллекция: total как раньше + разбивка по группам.
// Общий ScatterCollection остаётся {[date]: number} — заметки не трогаем.
export type LogsGroupedCollection = {
  [date: string]: {total: number; byGroup: GroupBreakdown};
};
